import { render, staticRenderFns } from "./min-score-completion-form.vue?vue&type=template&id=3f2501da&scoped=true&"
import script from "./min-score-completion-form.ts?vue&type=script&lang=ts&"
export * from "./min-score-completion-form.ts?vue&type=script&lang=ts&"
import style0 from "./min-score-completion-form.scss?vue&type=style&index=0&id=3f2501da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2501da",
  null
  
)

export default component.exports